export const WalletScreenRoute = "WalletScreenRoute";
export const PassportFileShareScreenRoute="PassportFileShareScreenRoute"
export const UploadFileScreenRoute = "UploadFileScreenRoute";
